
export const PANEL_FAMILY_NEO_1 = 'Neo 1'
export const PANEL_FAMILY_NEO_2 = 'Neo 2'
export const PANEL_FAMILY_POWER_MASTER = 'PowerMaster'
export const PANEL_FAMILY_DUALPATH = 'DualPath'
export const PANEL_FAMILY_FIBRO = 'Fibro'
export const PANEL_FAMILY_UNKNOWN = 'Unknown'